/**
 * Module-based color theme configuration
 * Each route maps to a module color for consistent theming
 */

export const SECTION_THEMES = {
  Planning: { color: '#4F46E5', light: '#EEF2FF' },
  Execution: { color: '#059669', light: '#ECFDF5' },
  Finance: { color: '#DC2626', light: '#FEF2F2' },
  Inventory: { color: '#D97706', light: '#FFFBEB' },
  Documents: { color: '#7C3AED', light: '#F5F3FF' },
  Reports: { color: '#0D9488', light: '#F0FDFA' },
  Admin: { color: '#6B7280', light: '#F9FAFB' },
  'Super Admin': { color: '#1A1F36', light: '#F0F0F4' },
};

export const ROUTE_THEMES = {
  '/':                    { color: '#2563EB', section: 'Planning', label: 'Dashboard' },
  '/users':               { color: '#4F46E5', section: 'Planning', label: 'Users' },
  '/projects':            { color: '#4F46E5', section: 'Planning', label: 'Projects' },
  '/teams':               { color: '#059669', section: 'Planning', label: 'Teams' },
  '/wbs':                 { color: '#4F46E5', section: 'Planning', label: 'WBS' },
  '/milestones-tasks':    { color: '#4F46E5', section: 'Planning', label: 'Milestones & Tasks' },
  '/daily-logs':          { color: '#059669', section: 'Execution', label: 'Daily Logs' },
  '/manpower':            { color: '#059669', section: 'Execution', label: 'Manpower' },
  '/materials':           { color: '#D97706', section: 'Execution', label: 'Materials' },
  '/team-reports':        { color: '#059669', section: 'Execution', label: 'Team Reports' },
  '/productivity':        { color: '#059669', section: 'Execution', label: 'Productivity' },
  '/budgets':             { color: '#DC2626', section: 'Finance', label: 'Budgets' },
  '/costs':               { color: '#DC2626', section: 'Finance', label: 'Costs' },
  '/budget-vs-actual':    { color: '#DC2626', section: 'Finance', label: 'Budget vs Actual' },
  '/invoices':            { color: '#DC2626', section: 'Finance', label: 'Invoices' },
  '/payments':            { color: '#DC2626', section: 'Finance', label: 'Payments' },
  '/variations':          { color: '#DC2626', section: 'Finance', label: 'Variations' },
  '/financial-dashboard': { color: '#DC2626', section: 'Finance', label: 'Financial Dashboard' },
  '/vat-report':          { color: '#DC2626', section: 'Finance', label: 'VAT Report' },
  '/payroll':             { color: '#DC2626', section: 'Finance', label: 'Payroll' },
  '/accounting':          { color: '#DC2626', section: 'Finance', label: 'Accounting' },
  '/inventory':           { color: '#D97706', section: 'Execution', label: 'Inventory' },
  '/advanced-reports':    { color: '#0D9488', section: 'Reports', label: 'Advanced Reports' },
  '/documents':           { color: '#7C3AED', section: 'Documents', label: 'Documents' },
  '/approvals':           { color: '#7C3AED', section: 'Documents', label: 'Approvals' },
  '/reports':             { color: '#0D9488', section: 'Reports', label: 'Weekly Reports' },
  '/executive-dashboard': { color: '#0D9488', section: 'Reports', label: 'Executive Dashboard' },
  '/project-dashboard':   { color: '#0D9488', section: 'Reports', label: 'Project Dashboard' },
  '/site-dashboard':      { color: '#0D9488', section: 'Reports', label: 'Site Dashboard' },
  '/notifications':       { color: '#6B7280', section: 'Admin', label: 'Notifications' },
  '/calendar':            { color: '#6B7280', section: 'Admin', label: 'Calendar' },
  '/meetings':            { color: '#6B7280', section: 'Admin', label: 'Meeting Notes' },
  '/settings':            { color: '#6B7280', section: 'Admin', label: 'Settings' },
  '/tax-settings':        { color: '#6B7280', section: 'Admin', label: 'Tax Settings' },
  '/legal-admin':         { color: '#6B7280', section: 'Admin', label: 'Legal & Compliance' },
  '/legal/:type':         { color: '#6B7280', section: 'Admin', label: 'Legal' },
  '/super-admin':         { color: '#1A1F36', section: 'Super Admin', label: 'Control Panel' },
  '/user-guide':          { color: '#6B7280', section: 'Admin', label: 'User Guide' },
  '/audit-log':           { color: '#6B7280', section: 'Admin', label: 'Audit Log' },
  '/role-permissions':    { color: '#6B7280', section: 'Admin', label: 'Role Permissions' },
};

export function getTheme(pathname) {
  return ROUTE_THEMES[pathname] || { color: '#2563EB', section: 'Planning', label: 'Dashboard' };
}
